import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import cloneDeep from 'lodash/cloneDeep';
/**
 *
 * @param {Object} payload payload
 * @param {Object} payload.familyGroupsByType family groups by type
 * @param {Object} payload.majorGroupsByFamilyGroupAndType major groups by family
 * @param {Object} payload.products products by type
 * @param {Object} payload.question menu insight question
 * @param {Object} payload.type type ref
 *
 * @returns {Array} array of 'dishes' based on family groups
 *
 */

export function getTypeDishes(_ref) {
  var familyGroupsByType = _ref.familyGroupsByType,
      majorGroupsByFamilyGroupAndType = _ref.majorGroupsByFamilyGroupAndType,
      products = _ref.products,
      question = _ref.question,
      type = _ref.type;

  if (!familyGroupsByType || !type || !majorGroupsByFamilyGroupAndType) {
    return [];
  } // loop through family groups and create a new top level 'dish' object for each 'category'


  var familyGroups = familyGroupsByType[type] || [];
  var dishes = familyGroups.map(function (fg) {
    var _majorGroupsByFamilyG;

    var mgbfat = (_majorGroupsByFamilyG = majorGroupsByFamilyGroupAndType[type]) === null || _majorGroupsByFamilyG === void 0 ? void 0 : _majorGroupsByFamilyG[fg.ref]; // calculate category options by major group if available

    var categoryOptions = Array.isArray(mgbfat) ? mgbfat.map(function (mg) {
      var _products$question$me, _products$question$me2;

      // loop through major groups and create a new object for each 'subcategory'
      var selected = (products === null || products === void 0 ? void 0 : (_products$question$me = products[question.menuType]) === null || _products$question$me === void 0 ? void 0 : (_products$question$me2 = _products$question$me[fg.ref]) === null || _products$question$me2 === void 0 ? void 0 : _products$question$me2[mg.ref]) || [];
      var subcategoryOptions = getSubcategoryOptionsByMajorGroup(question, selected);
      return {
        name: mg.name,
        options: subcategoryOptions,
        ref: mg.ref,
        subcategory: mg.name,
        isMisc: mg.isMisc
      };
    }) : [];
    var category = {
      category: fg.name,
      image: null,
      // This is for tiled MI questions only (currently not supported)
      name: fg.name,
      options: categoryOptions,
      ref: fg.ref
    };
    return category;
  });
  return dishes;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Object} product product
 *
 * @returns {Array} array of subquestions for the subcategory
 *
 */

export function getSubquestionsForSubcategory(question, product) {
  var subQuestions = [];
  var ratings = cloneDeep(question.ratings); // create subQuestion for each rating

  for (var i in ratings) {
    var rating = cloneDeep(ratings[i]);
    var reasonSections = cloneDeep(rating.reasonSections);

    for (var j in reasonSections) {
      var section = cloneDeep(reasonSections[j]);
      var sectionOptions = section.reasons.map(function (r) {
        return {
          id: r.id,
          label: r.text,
          val: r.id
        };
      });
      subQuestions.push({
        id: 'question' + question.id + 'product' + product.ref + 'rating' + i + 'reasonSection' + j,
        type: 'fib-select-option',
        showIf: section.showIf,
        required: false,
        // TODO - find out what sets this
        label: section.title,
        meta: {
          rating: rating,
          section: section
        },
        props: {
          center: true,
          multiple: true,
          options: sectionOptions
        }
      });
    }
  } // add comments box if applicable


  subQuestions.push({
    id: 'question' + question.id + 'product' + product.ref + 'comment',
    type: 'fib-comments',
    required: true,
    // TODO : find out if this needs setting and how to check if it is
    label: '',
    props: {
      rows: 6
    }
  });
  return subQuestions;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products products
 *
 * @returns {Array} array of subcategory options for the major group
 *
 */

function getSubcategoryOptionsByMajorGroup(question, products) {
  if (!Array.isArray(products)) {
    throw 'getSubcategoryOptionsByMajorGroup requires array of products';
  }

  return products.map(function (p) {
    var option = {
      id: p.ref,
      ref: p.ref,
      title: p.name
    }; // if follow up questions turned on, add subQuestions

    if (question.followUpQuestion) {
      option.subQuestions = getSubquestionsForSubcategory(question, p);
    }

    return option;
  });
}

export default {
  getSubquestionsForSubcategory: getSubquestionsForSubcategory,
  getTypeDishes: getTypeDishes
};